<template>
    <tbody>
    <tr v-if="row.is_separator">
        <th colspan="8">{{ row.name }}</th>
    </tr>

    <tr v-else class="period-budget" @click="toggle" style="cursor:pointer">
        <td>
            <span v-if="row.is_new_client" class="fas fa-asterisk" style="color:gold" title="New Company"></span>
            {{ row.name }}
            <employer-icons :employer="row.employer"></employer-icons>
            <span v-if="row.agency_name" class="job-tag"><a
                style="background:#ecf0f1;border: 1px solid #b1c2c6;">{{ row.agency_name }}</a></span>
            <i :class="[ 'glyphicon', isOpen ? 'glyphicon-collapse-down' : 'glyphicon-collapse-up', 'is-aligned-right' ]"></i>
        </td>
        <td>
            <span v-if="!isNaN(row.budget)">{{ money(row.budget) }}</span>
            <span v-else-if="row.budget">{{ row.budget }}</span>
            <template v-if="!isNaN(row.addons)"><br><i>{{ money(row.addons) }}</i></template>
        </td>
        <td>
            <span v-if="!isNaN(row.billable)">{{ money(row.billable) }}</span>
            <span v-else-if="row.billable">{{ row.billable }}</span>
        </td>
        <td><span v-if="row.value">{{ money(row.value) }}</span></td>
        <td>{{ row.subscription_type }}</td>
        <td @click.stop="">
            <a href="#" class="dashed-link" @click.prevent="openNetInvoiceDialog">{{ row.net_invoice }}</a>
            <i v-if="row.payments_count > 0" class="far fa-credit-card" aria-hidden="true"></i>
        </td>
        <td @click.stop="">
            <a href="#" class="dashed-link" @click.prevent="openPaymentStatusDialog">{{ row.paid_status_text }}</a>
        </td>
        <td @click.stop="">
            <a :href="url(`/admin/employer/${row.employer_id}/payments`)">Edit</a>
        </td>
    </tr>

    <tr v-if="isOpen">
        <td colspan="8" v-loading="!isLoaded">
            <BtreePaymentInput :transactions="btreeTransactions"
                               @unlinked="btreePaymentUnlinked"></BtreePaymentInput>
            <StripePaymentInput :charges="stripeCharges"
                                @unlinked="stripePaymentUnlinked"></StripePaymentInput>
            <PaymentsNotesInput :notes="notes"
                                :budget-period-id="row.id"
                                @noted="notesChanged"></PaymentsNotesInput>
        </td>
    </tr>
    </tbody>
</template>

<script>
import BtreePaymentInput from './../../RevenueBraintree/vue/payment-input';
import StripePaymentInput from './../../RevenueStripe/vue/payment-input';
import PaymentsNotesInput from './notes-input';

export default {
    components: { BtreePaymentInput, StripePaymentInput, PaymentsNotesInput },
    props: {
        row: { type: Object, required: true },
        index: { type: [String, Number], required: true },
    },
    data() {
        return {
            isOpen: false,
            isLoaded: false,
            btreeTransactions: [],
            stripeCharges: [],
            notes: [],
        };
    },
    mounted() {},
    methods: {
        toggle() {
            if (!this.isOpen && !this.isLoaded) this.loadInnerData();
            this.isOpen = !this.isOpen;
        },
        btreePaymentUnlinked(newTransactions) {
            this.btreeTransactions = newTransactions;
        },
        stripePaymentUnlinked(newCharges) {
            this.stripeCharges = newCharges;
        },
        notesChanged(newNotes) {
            this.notes = newNotes;
        },
        openNetInvoiceDialog() {
            this.$emit('open-net-invoice-dialog', {
                period: this.row.id,
                value: this.row.net_invoice,
                employer: this.row.employer_id,
                index: this.index,
            });
        },
        openPaymentStatusDialog() {
            let value = 'Assumed';
            if (this.row.paid_status_text.includes('Paid')) value = 'Paid';
            else if (this.row.paid_status_text.includes('Invoiced')) value = 'Invoiced';

            this.$emit('open-payment-status-dialog', {
                period: this.row.id,
                value: value,
                employer: this.row.employer_id,
                index: this.index,
            });
        },
        loadInnerData() {
            this.isLoaded = false;
            return axios.get(url(`admin/payments/get-data-inner`), {
                params: {
                    period_id: this.row.id,
                },
            }).then(response => {
                this.btreeTransactions = response.data.btree_transactions;
                this.stripeCharges = response.data.stripe_charges;
                this.notes = response.data.notes;

                this.isLoaded = true;
            });
        },
    },
};
</script>

<style scoped>
a.dashed-link {
    border-bottom: 1px dashed #0088cc;
    text-decoration: none;
}
</style>